import React from "react";
import type { IHighlight } from "./react-pdf-highlighter";
import {
  Breadcrumb,
  Button,
  Space,
  Form,
  Input,
  Row,
  Col,
  Checkbox,
  Upload,
  Spin,
  Radio,
  Select,
  DatePicker,
  List,
  Comment,
  Image,
  Avatar,
  Tabs,
} from "antd";
import {
  MoreOutlined,
  LoadingOutlined,
  UserOutlined,
  SyncOutlined,
  DownloadOutlined,
  PrinterOutlined,
  CheckCircleOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { IoMdAttach } from 'react-icons/io';
import "./style/sidebar.css";
import history from "../../history";
import MinuteStageApprover from "../MinuteStageApprover";
import DocumentSeenStamp from '../DocumentSeenStamp/index'
import DocumentComments from '../DocumentComments/index'
import DocumentEditHistory from "../DocumentEditHistory/index";
const { TabPane } = Tabs;

const data = [
  {
    stage: '0',
    title: 'Rayan Homer',
    status: 'Signed',
  },
  {
    stage: '1',
    title: 'Rayan Homer',
    status: 'Pending Sign',
  },
  {
    stage: '2',
    title: 'Rayan Homer',
    status: 'Pending Sign',
  },
  {
    stage: '3',
    title: 'Rayan Homer',
    status: 'Pending Sign',
  },
];

const commentdata = [
  {
    name: 'Jim Doe',
    role: 'Clerk',
    highlight: 'Certificate of education',
    comment: 'Please check',
    image: null,
    document: null,
    date: '30/09/2021, 11:00 PM',
    replies: [
      {
        name: 'Nicole Kelly',
        role: 'Director',
        reply: 'tagged here',
        image: null,
        document: null,
        date: '30/09/2021, 11:00 PM',
      },
      {
        name: 'Nicole Kelly',
        role: 'Director',
        reply: 'Already tagged here',
        image: null,
        document: null,
        date: '30/09/2021, 11:00 PM',
      },
      {
        name: 'Nicole Kelly',
        role: 'Director',
        reply: 'check please',
        image: null,
        document: null,
        date: '30/09/2021, 11:00 PM',
      },
      {
        name: 'Nicole Kelly',
        role: 'Director',
        reply: 'Checked',
        image: null,
        document: null,
        date: '30/09/2021, 11:00 PM',
      }
    ]
  },
  {
    name: 'Nicole Kelly',
    role: 'Director',
    highlight: '',
    comment: 'Check below',
    image: null,
    document: null,
    date: '30/09/2021, 11:00 PM',
    replies: []
  },
  {
    name: 'Jim Doe',
    role: 'Clerk',
    highlight: '',
    comment: '',
    image: 'default-View-SubAdmin-Img.png',
    document: null,
    date: '30/09/2021, 11:00 PM',
    replies: []
  },
  {
    name: 'Jim Doe',
    role: 'Clerk',
    highlight: '',
    comment: 'Upload document',
    image: null,
    document: null,
    date: '30/09/2021, 11:00 PM',
    replies: [{
      name: 'Nicole Kelly',
      role: 'Director',
      reply: 'Ok',
      image: null,
      document: null,
      date: '30/09/2021, 11:00 PM',
    }]
  },
];

interface Props {
  highlights: Array<IHighlight>;
  resetHighlights: () => void;
  toggleDocument: () => void;
  seenStamp: boolean;
}

const updateHash = (highlight: IHighlight) => {
  document.location.hash = `highlight-${highlight.id}`;
  setTimeout(() => {
    history.goBack();
  }, 2000);

};

function callback(key) {
  // console.log(key);
}

function callbackTreatedBy(key) {
  // console.log(key);
}



export function Sidebar({
  highlights,
  toggleDocument,
  resetHighlights,
  seenStamp,
}: Props) {
  return (
    <div className="sidebar verify-document-sidebar" style={{ height: '100%' }}>
      {/* <Row> 
    <Col span={16} style={{textAlign:'left'}}>
      <Space>
      <Button type="primary" icon={<DownloadOutlined/>} ghost>Download</Button>
      <Button type={'primary'} icon={<PrinterOutlined/>} ghost>Print</Button>
      </Space>
    </Col>
    <Col span={8}>
    </Col>
    </Row> */}
      {/* <Tabs defaultActiveKey="1" onChange={callback}  size={'large'} centered={true}> */}
      <Tabs defaultActiveKey="1" onChange={callback} style={{display:'contents'}} >
        <TabPane tab="Minutes" key="1"
        // style={{padding:'5px 0px 0px 30px'}}
        >
          {seenStamp
            ? <DocumentSeenStamp />
            : <DocumentSeenStamp />
            // : <MinuteStageApprover />
          }


          {/*  */}
        </TabPane>
        <TabPane tab="Treated By" key="2" >
          <Tabs className={'treatedbyclass'} defaultActiveKey="highlight" onChange={callbackTreatedBy}  >
            <TabPane tab="Highlights" key="highlight"
            // style={{padding:'5px 0px 0px 30px'}}
            >
              <div className="sidebar" style={{ width: "100%", height: '75vh' }}>
                {/* <div className="description" style={{ padding: "1rem" }}>

        <p>
          <small>
            To create area highlight hold ⌥ Option key (Alt), then click and
            drag.
          </small>
        </p>
      </div> */}
                {highlights && highlights.length > 0
                  ? <ul className="sidebar__highlights" >
                    {highlights.map((highlight, index) => (
                      <li
                        key={index}
                        className="sidebar__highlight"
                        onClick={() => {
                          updateHash(highlight);
                        }}
                      >
                        <div>
                          <strong>{highlight.comment.text}</strong>
                          {highlight.content.text ? (
                            <blockquote style={{ marginTop: "0.5rem" }}>
                              {`${highlight.content.text.slice(0, 90).trim()}…`}
                            </blockquote>
                          ) : null}
                          {highlight.content.image ? (
                            <div
                              className="highlight__image"
                              style={{ marginTop: "0.5rem" }}
                            >
                              <img src={highlight.content.image} alt={"Screenshot"} />
                            </div>
                          ) : null}
                        </div>
                        <div className="highlight__location">
                          Page {highlight.position.pageNumber}
                        </div>
                      </li>
                    ))}
                  </ul>
                  : <ul className="sidebar__highlights" >
                    <li
                    >
                      <div style={{ paddingTop: 50 }}>
                        <strong>No Highlights Found</strong>
                      </div>
                    </li>
                  </ul>
                }

                {/* <div style={{ padding: "1rem" }}>
        <button onClick={toggleDocument}>Toggle PDF document</button>
      </div> */}
                {/* {highlights.length > 0 ? (
        <div style={{ padding: "1rem" }}>
          <button onClick={resetHighlights}>Reset highlights</button>
        </div>
      ) : null} */}
              </div>

            </TabPane>
            <TabPane tab="Comments" key="comments"
            // style={{padding:'5px 0px 0px 30px'}}
            >
              <DocumentComments />
              {/* <List
    style={{width:'100%',height:'75vh',paddingBottom:20,paddingLeft:5,paddingRight:5,overflow: 'auto'}}
    itemLayout="horizontal"
    dataSource={commentdata}
    renderItem={item => (
      <>
      <div style={{marginBottom:item.replies && item.replies.length > 0?0:0,border:'1px solid #dfe0eb',borderBottom:0,padding:'5px 10px 0px 10px'}}>
      <List.Item>
        <List.Item.Meta
          style={{textAlign:'left'}}
          avatar={<Avatar className={'avtar-img'} src="./images/doc-user-image.png" />}
          title={<Row>
             <Col span={20} style={{textAlign:'left'}}>
              <span style={{fontSize:18,fontWeight:500}}>{item.name}</span>
              <br/>
              <span style={{color:'#9B9B9B'}}>{item.role}</span>
             </Col>
             <Col span={4} style={{textAlign:'right'}}>
             <span style={{fontSize:16,fontWeight:500}}><MoreOutlined /></span>
         </Col>
          </Row>}
          description={
            <Row>
             <Col span={24} style={{textAlign:'left'}}>
               {item.highlight &&
                <>
                Has highlighted <span style={{fontSize:15,color:"#decb0b",width:'100%'}}> "{item.highlight}"</span>
                <br/>
                </>
               }
              {item.image && 
                <Image
                width={150}
                height={150}
                src="error"
                fallback="data:image/png;base64,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"
              />
              }
              <span style={{fontSize:15,color:"#000",width:'100%'}}>{item.comment}</span>
             </Col>
          </Row>
             }
        />
      </List.Item>
      </div>
    
      <div style={{padding: 0,marginBottom:10,border:'1px solid #dfe0eb'}}>
      {item.replies && item.replies.length > 0 &&
      <>
       <List.Item style={{padding: 0,borderBottom:0}}>
      <List
      style={{width:'100%',height:'100%',overflow: 'auto'}}
      itemLayout="horizontal"
      dataSource={item.replies}
      renderItem={ritem => (
      <>
        <div style={{marginTop:0,marginBottom:0,padding:'5px 10px 0px 30px'}}>
      <List.Item >
        <List.Item.Meta
          style={{textAlign:'left'}}
          avatar={<Avatar className={'avtar-img'} src="./images/doc-user-image.png" />}
          title={<Row>
             <Col span={20} style={{textAlign:'left'}}>
              <span style={{fontSize:18,fontWeight:500}}>{ritem.name}</span>
              <br/>
              <span style={{color:'#9B9B9B'}}>{ritem.role}</span>
             </Col>
             <Col span={4} style={{textAlign:'right'}}>
             <span style={{fontSize:16,fontWeight:500}}><MoreOutlined /></span>
         </Col>
          </Row>}
          description={
            <Row>
             <Col span={24} style={{textAlign:'left'}}>
              {ritem.image && 
                <Image
                width={150}
                height={150}
                src="error"
                fallback="data:image/png;base64,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"
              />
              }
              <span style={{fontSize:15,color:"#000",width:'100%'}}>{ritem.reply}</span>
             </Col>
          </Row>
             }
        />
      </List.Item>
      </div>
      </>
    )}
  />
   </List.Item>
   <Input
    className={'replyinputclass'}
    style={{width:'90%',background: '#F2F2F2',marginTop:10,marginBottom:10,marginLeft:10,marginRight:10,border: '1px solid #dfe0eb',borderTopColor:'#dfe0eb',borderRadius:32}}
    placeholder="Add a reply"
    suffix={
        <IoMdAttach style={{ color: 'rgba(0,0,0,.45)' }} />
    }
  />
      </>
      }
     
      </div>
      </>
    )}
  /> */}

            </TabPane>
          </Tabs>



        </TabPane>


        <TabPane tab="Edit History" key="3" className="history-main-tab">
          <DocumentEditHistory />
        </TabPane>

      </Tabs>
    </div>

  );
}
